import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { useLocation } from "react-router-dom";

const WhatsAppFloat = () => {
  const location = useLocation();

  // Hide icon on contact page
  if (location.pathname === "/contact") return null;

  return (
<a
  href="https://wa.me/918383002598"
  target="_blank"
  rel="noopener noreferrer"
  className="fixed bottom-6 right-6 bg-[#25D366] text-white p-4 rounded-full shadow-lg hover:scale-110 transition-transform duration-200 z-50"
  aria-label="Chat on WhatsApp"
>
  <FaWhatsapp className="w-6 h-6 animate-pulse" />
</a>
  );
};

export default WhatsAppFloat;